export default __webpack_public_path__ + "static/media/bw.d6b0b330.svg";